import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSellingCurrency } from "../../pages/hooks/sellingCurrency";

export function withPrefillSellingCurrency(Component: React.ComponentType): React.FC {
    const Result = (props: any) => {
        const dispatch = useDispatch();
        const sellingCurrency = useSellingCurrency();

        useEffect(() => {
            if (sellingCurrency) {
                dispatch({
                    type: 'TRIP_SET_CURRENCY',
                    payload: {
                        currency: sellingCurrency
                    }
                });
            }
        }, [sellingCurrency]);

        return (
            <Component {...props} />
        );
    }
    Result.displayName = `withPrefillSellingCurrency(${Component.displayName})`;
    return Result;
}